import sliders from '../../../src/js/shared/sliders';

'use strict';
const $ = jQuery.noConflict();
$(function() {

	const logoSlider = {

		init: function() {
			this.sliderInit();
		},

		sliderInit: function() {
			const sliderConfig = {
				slidesToShow: 6,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 0,
				speed: 5000,
				cssEase: 'linear',
				pauseOnHover: false,
				pauseOnFocus: false,
				swipe: false,
				arrows: false,
				responsive: [
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 4
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 575,
						settings: {
							slidesToShow: 2
						}
					}
				]
			};

			sliders.initializeSlider('.js-logo-slider', sliderConfig);
		},

	};

	logoSlider.init();

});
